import { parseJSON } from '@/components/helpers/utils'

// Custom hook for card options
export const useRecommendationCardSettings = (productCardSettings) => {
  const parsedProductCardSettings = parseJSON(productCardSettings)

  const cardSettings = productCardSettings && Object.keys(parsedProductCardSettings).length > 0 ? parsedProductCardSettings : {}

  return { cardSettings, parsedProductCardSettings }
}
